module.exports = __webpack_public_path__ + "img/gems_error_logo.b4e2b887.png";